const INITIAL_STATE = {
  data: null,
  error: null,
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "FETCH_SUBURB_SUCCESS":
      return { ...state, data: action.payload };

    case "FETCH_SUBURB_FAIL":
      return { ...state, error: action.payload };

    default:
      return state;
  }
};
